module.exports = __webpack_public_path__ + "static/media/inlarge-ic.2606a1ec.svg";